export enum CommentType {
  Letter,
  SeasonRecord,
  MeritRecord,
  General
}
